<div class="connection-container bg-white shadow-lg">
  <div class="row align-items-end">
    <div class="col-auto">
      <div class="company-img">
        <img class="img-fluid"
          src="../../../assets/images/logo-login.png"
          alt="Groupe Gesco Assurances"
          />
        </div>
      </div>
      <div class="col">
        <h2 class="mb-4" translate>LOGIN_LBL_RESET_PASSWORD</h2>
      </div>
    </div>
    <!--<h2 class="mb-4">Changer mot de passe</h2>-->
    <input type="hidden" name="returnUrl" value="@ViewBag.ReturnUrl"/>
    <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
      @if (this.showErrorLogin) {
        <div
          class="alert {{this.css}}"
          id="validationSummary"
          >
          <ul>
            <li translate>{{ this.msgError }}</li>
          </ul>
        </div>
      }
      @if (resetPasswordForm.errors?.['PasswordNoMatch']) {
        <div class="alert {{this.css}}">
          <ul>
            <li translate>LOGIN_LBL_RESET_PASSWORD_ERRORS_MATCH</li>
          </ul>
        </div>
      }
      <div class="form-group mb-4">
        <label for="password" class="form-label" translate
          >LOGIN_LBL_RESET_PASSWORD_PASSWORD</label
          >
          <div class="input-group position-relative">
            <input
              #password
              id="password"
              type="password"
              formControlName="password"
              class="form-control form-control-md input-eye"
              required
              checkFormFieldValidity
              />
              <span class="input-group-text position-absolute end-0 eye"
                (click)="password.type = password.type === 'password' ? 'text' : 'password'"
                role="button" tabindex="0">
                <i [class]="password.type === 'password' ? 'mdi mdi-eye-outline' : 'mdi mdi-eye-off-outline'"></i>
              </span>
            </div>
          </div>
          <div class="row mb-4">
            <div class="col">
              <ul class="no-bullets">
                <li>Doit avoir au moins de 6 caractères</li>
                <li>Doit contenir au moins une majuscule et une minuscule (A, z)</li>
                <li>Doit contenir au moins un nombre</li>
                <li>Doit contenir au moins un caractère spécial (!, %, &#64;, #, etc.)</li>
              </ul>
            </div>
          </div>
          <div class="form-group mb-4">
            <label for="password" class="form-label" translate
              >LOGIN_LBL_RESET_PASSWORD_PASSWORD_CONFIRM</label
              >
              <div class="input-group position-relative">
                <input
                  #password2
                  id="passwordConfirm"
                  type="password"
                  formControlName="passwordConfirm"
                  class="form-control form-control-md input-eye"
                  required
                  checkFormFieldValidity
                  />
                  <span class="input-group-text position-absolute end-0 eye"
                    (click)="password2.type = password2.type === 'password' ? 'text' : 'password'"
                    role="button" tabindex="0">
                    <i [class]="password2.type === 'password' ? 'mdi mdi-eye-outline' : 'mdi mdi-eye-off-outline'"></i>
                  </span>
                </div>
              </div>
              <div class="text-right">
                <button
                  [routerLink]="'/'"
                  class="btn-outline-primary btn me-2"
                  translate
                  >
                  LOGIN_BTN_RESET_PASSWORD_HOME
                </button>
                <!--    [disabled]="resetPasswordForm.invalid"-->
                <button type="submit" class="btn btn-primary" translate>
                  LOGIN_BTN_RESET_PASSWORD_REINIT
                </button>
              </div>
            </form>
          </div>
